import { Navigate } from 'react-router-dom'

export const routes = [
  {
    path: 'dashboard',
    async lazy() {
      const Comp = await import('../pages/dashboard/pages/index')
      return { Component: Comp.default }
    },
  },
  {
    path: 'createOrder',
    async lazy() {
      const Comp = await import('../../modules/createOrder/pages/index')
      return { Component: Comp.default }
    },
  },
  {
    path: 'createOrderFast',
    async lazy() {
      const Comp = await import('../../modules/createOrderFast/pages/index')
      return { Component: Comp.default }
    },
  },
  {
    path: 'trips',
    async lazy() {
      const Comp = await import('../../modules/dashboard/pages/index')
      return { Component: Comp.default }
    },
  },
  {
    path: 'upcomings',
    async lazy() {
      const Comp = await import('../../modules/upcomings/pages/index')
      return { Component: Comp.default }
    },
  },
  {
    path: 'employee',
    async lazy() {
      const Comp = await import('../../modules/people/pages/entry')
      return { Component: Comp.default }
    },
    children: [
      {
        index: true,
        async lazy() {
          const Comp = await import('../../modules/people/pages')
          return { Component: Comp.default }
        },
      },
      {
        path: `:id`,
        async lazy() {
          const Comp = await import('../../modules/people/pages/details/index')
          return { Component: Comp.default }
        },
        children: [
          {
            index: true,
            element: <Navigate to="details" replace />,
          },
          {
            path: 'details',
            async lazy() {
              const Comp = await import('../../modules/people/pages/details/index')
              return { Component: Comp.default }
            },
          },
        ],
      },
    ],
  },
  {
    path: 'invites',
    async lazy() {
      const Comp = await import('../../modules/invites/pages/entry')
      return { Component: Comp.default }
    },
    children: [
      {
        index: true,
        async lazy() {
          const Comp = await import('../../modules/invites/pages')
          return { Component: Comp.default }
        },
      },
      {
        path: `:id`,
        async lazy() {
          const Comp = await import('../../modules/invites/pages/details/index')
          return { Component: Comp.default }
        },
        children: [
          {
            index: true,
            element: <Navigate to="details" replace />,
          },
          {
            path: 'details',
            async lazy() {
              const Comp = await import('../../modules/invites/pages/details/index')
              return { Component: Comp.default }
            },
          },
        ],
      },
    ],
  },
  {
    path: '/settings/rules',
    async lazy() {
      const Comp = await import('../../modules/settings/pages/rules/entry')
      return { Component: Comp.default }
    },
    children: [
      {
        index: true,
        async lazy() {
          const Comp = await import('../../modules/settings/pages/rules')
          return { Component: Comp.default }
        },
      },
      {
        path: `:id`,
        async lazy() {
          const Comp = await import('../../modules/settings/pages/rules/Edit/index')
          return { Component: Comp.default }
        },
        children: [
          {
            index: true,
            element: <Navigate to="details" replace />,
          },
          {
            path: 'details',
            async lazy() {
              const Comp = await import('../../modules/settings/pages/rules/Edit/index')
              return { Component: Comp.default }
            },
          },
        ],
      },
    ],
  },
  {
    path: '/settings/labels',
    async lazy() {
      const Comp = await import('../../modules/settings/pages/labels/entry')
      return { Component: Comp.default }
    },
    children: [
      {
        index: true,
        async lazy() {
          const Comp = await import('../../modules/settings/pages/labels')
          return { Component: Comp.default }
        },
      },
      {
        path: `:id`,
        async lazy() {
          const Comp = await import('../../modules/settings/pages/labels/details/Edit/index')
          return { Component: Comp.default }
        },
        children: [
          {
            index: true,
            element: <Navigate to="details" replace />,
          },
          {
            path: 'details',
            async lazy() {
              const Comp = await import('../../modules/settings/pages/labels/details/Edit/index')
              return { Component: Comp.default }
            },
          },
        ],
      },
    ],
  },
  {
    path: '/settings/account/create',
    async lazy() {
      const Comp = await import('../../modules/settings/pages/account/create')
      return { Component: Comp.default }
    },
    exact: true,
  },
  {
    path: '/settings/account/edit',
    async lazy() {
      const Comp = await import('../../modules/settings/pages/account/edit')
      return { Component: Comp.default }
    },
    exact: true,
  },
  {
    path: '/finance/transactions',
    async lazy() {
      const Comp = await import('../../modules/finance/pages/transactions')
      return { Component: Comp.default }
    },
    exact: true,
  },
  {
    path: '/finance/cards',
    async lazy() {
      const Comp = await import('../../modules/finance/pages/cards')
      return { Component: Comp.default }
    },
    exact: true,
  },
  {
    path: '/finance/cards/add',
    async lazy() {
      const Comp = await import('../../modules/finance/pages/cards/add')
      return { Component: Comp.default }
    },
    exact: true,
  },
]
